import { useFormContext } from 'react-hook-form';
import { useStateMachine } from 'little-state-machine';

import {
  Input,
  Radio,
  MedicalConditions,
  Disqualification,
  Date,
} from '@/components/fields';
import { useTheme } from '@/contexts/ThemeContext';

export default function RenewalOldDetails(): JSX.Element {
  const { errors, watch } = useFormContext();
  const { landingPage } = useTheme();
  const {
    state: {
      form: { licenceNumber },
    },
  } = useStateMachine();
  const notPossessLicence = watch('possess_licence') === 'possess_licence_no';

  return (
    <>
      <div>
        {landingPage !== 'v12' && landingPage !== 'v13' && (
          <h3 className="bg-box-header text-xl leading-8 font-medium tracking-tight text-white flex items-center mb-5 py-2 px-4">
            Basic Details
          </h3>
        )}
        <div className="px-6 py-1">
          <div className="md:flex md:items-center">
            <div className="md:w-2/5 md:pr-4">
              <span className="block text-sm leading-5 font-normal text-gray-900">
                Please select the type of licence you have{' '}
                <sup className="text-red-600 font-sans">*</sup>
              </span>
            </div>
            <div className="md:w-2/5 md:pl-4">
              <div className="flex items-center">
                <Radio name="licence_type" id="paper_licence" className="mr-4">
                  Paper licence
                </Radio>
                <Radio name="licence_type" id="photocard_couterpart_licence">
                  Photocard + Counterpart licence
                </Radio>
              </div>
              {errors['licence_type'] ? (
                <p className="mb-4 font-medium text-sm text-red-600">
                  {errors['licence_type'].message}
                </p>
              ) : null}
            </div>
          </div>
          <div className="mt-4 md:flex md:items-center">
            <div className="md:w-2/5 md:pr-4">
              <span className="block text-sm leading-5 font-normal text-gray-900">
                Do you currently possess your licence?{' '}
                <sup className="text-red-600 font-sans">*</sup>
              </span>
            </div>
            <div className="md:w-2/5 md:pl-4">
              <div className="flex items-center">
                <Radio
                  name="possess_licence"
                  id="possess_licence_yes"
                  className="mr-4"
                >
                  Yes
                </Radio>
                <Radio
                  name="possess_licence"
                  id="possess_licence_no"
                  className="mr-4"
                >
                  No
                </Radio>
              </div>
              {errors['possess_licence'] ? (
                <p className="mb-4 font-medium text-sm text-red-600">
                  {errors['possess_licence'].message}
                </p>
              ) : null}
            </div>
          </div>
          {notPossessLicence ? (
            <div className="mt-4 md:flex md:items-center">
              <div className="md:w-2/5 md:pr-4">
                <span className="block text-sm leading-5 font-normal text-gray-900">
                  Please indicate if your licence has been Lost, Stolen or
                  Destroyed <sup className="text-red-600 font-sans">*</sup>
                </span>
              </div>
              <div className="mt-4 md:mt-0 md:w-2/5 md:pl-4">
                <div className="flex items-center">
                  <Radio name="licence_status" id="lost" className="mr-4">
                    Lost
                  </Radio>
                  <Radio name="licence_status" id="stolen" className="mr-4">
                    Stolen
                  </Radio>
                  <Radio name="licence_status" id="destroyed" className="mr-4">
                    Destroyed
                  </Radio>
                </div>
                {errors['licence_status'] ? (
                  <p className="mb-4 text-sm text-red-600">
                    {errors['licence_status'].message}
                  </p>
                ) : null}
              </div>
            </div>
          ) : null}
          {!licenceNumber && (
            <Input id="driver_number" className="mt-4" isRequired>
              Driver’s Licence Number
            </Input>
          )}
          <div className="mt-4">
            <Date
              id="licence_expiry_date"
              isRequired
              type="future"
              skipYears={-6}
            >
              Driver’s Licence Expiry Date
            </Date>
          </div>
          <div className="mt-4 md:flex md:items-center">
            <div className="md:w-2/5 md:pr-4">
              <span className="block text-sm leading-5 font-normal text-gray-900">
                Do you meet the legal eyesight standard for driving?{' '}
                <sup className="text-red-600 font-sans">*</sup>
              </span>
            </div>
            <div className="md:w-2/5 md:pl-4">
              <div className="flex items-center">
                <Radio
                  name="legal_eyesight"
                  id="legal_eyesight_yes"
                  className="mr-4"
                >
                  Yes
                </Radio>
                <Radio
                  name="legal_eyesight"
                  id="legal_eyesight_no"
                  className="mr-4"
                >
                  No
                </Radio>
              </div>
              {errors['legal_eyesight'] ? (
                <p className="mb-4 font-medium text-sm text-red-600">
                  {errors['legal_eyesight'].message}
                </p>
              ) : null}
            </div>
          </div>
          <div className="mt-4 md:flex md:items-center">
            <div className="md:w-2/5 md:pr-4">
              <span className="block text-sm leading-5 font-normal text-gray-900">
                Do you need to wear glasses or corrective lenses to meet this
                standard? <sup className="text-red-600 font-sans">*</sup>
              </span>
            </div>
            <div className="md:w-2/5 md:pl-4">
              <div className="flex items-center">
                <Radio
                  name="wear_glasses"
                  id="wear_glasses_yes"
                  className="mr-4"
                >
                  Yes
                </Radio>
                <Radio
                  name="wear_glasses"
                  id="wear_glasses_no"
                  className="mr-4"
                >
                  No
                </Radio>
              </div>
              {errors['wear_glasses'] ? (
                <p className="mb-4 font-medium text-sm text-red-600">
                  {errors['wear_glasses'].message}
                </p>
              ) : null}
            </div>
          </div>
          <div className="mt-4">
            <Disqualification />
          </div>
          <MedicalConditions />
        </div>
      </div>
    </>
  );
}
